import React from 'react';
import { DashboardProvider } from '@/contexts/DashboardContext';

/**
 * Wrapper component that provides DashboardContext to the dashboard routes.
 * This ensures all dashboard pages have access to cached subscription and usage data.
 */
export const DashboardWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <DashboardProvider>
      {children}
    </DashboardProvider>
  );
};
